import { ICasino } from 'constants/types';
import { useMemo } from 'react';
import { useCasinoByIdQuery } from 'hooks/api/casino';

type Props = {
  skip?: boolean;
  casino_ids: string[] | string | undefined;
};

export const useCasinosByIds = ({ casino_ids, skip }: Props) => {
  const { data, isFetching } = useCasinoByIdQuery(
    {
      id: casino_ids?.toString() ?? '',
    },
    { skip: !casino_ids || skip }
  );

  const { casinos, count } = useMemo(() => {
    const casino = data as ICasino | null | undefined;
    if (!casino) {
      return { casinos: [] as ICasino[], count: 0 };
    }
    return { casinos: [casino], count: 1 };
  }, [data]);

  return { casinos, isFetching, count };
};
